<app-header></app-header>
<div class="container">
  <h1 class="title">Delete Branch</h1>
  <form [formGroup]="deleteBranchForm" (ngSubmit)="onSubmit()">
    <mat-card>
      <mat-card-content>
        <div class="form-fields">
          <mat-radio-group formControlName="repositoryProvider" class="repository-provider-group">
            <mat-label style="color: black;">Repo Provider:</mat-label>
            <mat-radio-button value="AzureDevOps">Azure DevOps</mat-radio-button>
            <mat-radio-button value="GitHub">GitHub</mat-radio-button>
          </mat-radio-group>

          @if (deleteBranchForm.get('repositoryProvider')?.value === 'GitHub') {
            <p class="github-note">
              <strong>Note:</strong> For GitHub repos, the branch will be deleted directly and a PR will not be created.
            </p>
          }

          <mat-form-field appearance="fill" [class.error-state]="hasError('repository')" [hideRequiredMarker]="true">
            <mat-label>Repository</mat-label>
            <input type="text"
              matInput
              formControlName="repository"
              [matAutocomplete]="repoAuto">
            <mat-autocomplete #repoAuto="matAutocomplete">
              @for (repo of filteredRepositories; track repo) {
                <mat-option [value]="repo.name">
                  {{ repo.name }}
                </mat-option>
              }
            </mat-autocomplete>
            @if (hasError('repository')) {
              <mat-error>
                Please enter a repository
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="fill" [class.error-state]="hasError('branchToDelete')" [hideRequiredMarker]="true">
            <mat-label>Branch To Delete</mat-label>
            <input type="text"
              matInput
              formControlName="branchToDelete"
              [matAutocomplete]="branchAuto">
            <mat-autocomplete #branchAuto="matAutocomplete">
              @for (branch of filteredBranches; track branch) {
                <mat-option [value]="branch">
                  {{ branch }}
                </mat-option>
              }
            </mat-autocomplete>
            @if (hasError('branchToDelete')) {
              <mat-error>
                {{ getErrorMessage('branchToDelete') }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-card-actions>
        <button mat-raised-button
          class="create-pr-button"
          type="submit"
          [disabled]="!deleteBranchForm.valid">
          {{ submitButtonText }}
        </button>
      </mat-card-actions>
    </mat-card>
  </form>
</div>